import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import {
  IDestinationCountry,
  IHomeCountry,
} from '@nibtravel/shared/util/models';
import { Observable, of, Subject } from 'rxjs';
import { mapTo, mergeMap, tap } from 'rxjs/operators';
import { CountriesDataService } from '../countries.data-service';
import {
  defaultCountriesState,
  ICountriesConfig,
} from '../models/countries-state.model';
import { HomeCountrySelected, LoadCountries } from './countries.action';

@State<ICountriesConfig>({
  name: 'countries',
  defaults: defaultCountriesState,
})
@Injectable()
export class CountriesState {
  destroy$!: Subject<void>;

  constructor(private countriesService: CountriesDataService) {}

  @Selector()
  public static getState(state: ICountriesConfig): ICountriesConfig {
    return state;
  }

  /**
   * returns homeCountries in array of ICountriesConfig format
   */
  @Selector()
  public static homeCountries(state: ICountriesConfig): IHomeCountry[] {
    return state.homeCountries;
  }

  /**
   * returns destinationCountries in array of { text: string; value: string } format fro dropdown
   * will be updated for multipicker
   */
  @Selector()
  public static destinationCountries(
    state: ICountriesConfig
  ): Record<string, any>[] {
    // TODO: return list as needed for IDRopdown for WS - need to work on making it work with aliases
    return state.destinationCountriesSelect;
  }

  @Selector()
  public static destinationCountriesList(
    state: ICountriesConfig
  ): IDestinationCountry[] {
    return state.destinationCountries || [];
  }

  @Selector()
  public static destinationRegionsList(
    state: ICountriesConfig
  ): IDestinationCountry[] {
    return state.destinationRegions;
  }

  @Selector()
  public static destinationRegions(
    state: ICountriesConfig
  ): Record<string, any>[] {
    return state.destinationRegionsSelect; // TODO
  }

  /**
   * Action handler to fetch the country list using country service and stored in Store
   * @param ctx
   * @param action
   */
  @Action(LoadCountries)
  loadCountries(
    ctx: StateContext<ICountriesConfig>,
    { brand }: LoadCountries
  ): Observable<any> {
    return this.countriesService.getCountriesConfig(brand).pipe(
      tap((data) => ctx.setState(patch({ ...data }))),
      mergeMap((data) => {
        if (data?.homeCountries?.length === 1) {
          return ctx
            .dispatch(new HomeCountrySelected(data?.homeCountries[0]))
            .pipe(mapTo(data));
        }
        return of(data);
      })
    );
  }
}
